'use strict';

const { ItemLocations } = require('../constants/Game');

const getLoadoutsAffectedByHeroItemLoss = ({
  from,
  from_game_item,
  hero_handle,
  loadouts,
  to_game_item,
}) => {
  const result = [];
  const game_item = from.location === ItemLocations.HERO_INVENTORY
    ? from_game_item
    : to_game_item;
  for (const [game_mode, submodes] of Object.entries(loadouts)) {
    for (const [game_submode, loadout] of Object.entries(submodes)) {
      const loadout_hero = loadout.find((hero) => hero.handle === hero_handle);
      if (Object.values(loadout_hero.equipment_assignment).includes(game_item.uid)) {
        result.push({ game_mode, game_submode });
      }
    }
  }

  return result;
};
module.exports = getLoadoutsAffectedByHeroItemLoss;
